import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as settingsActions from "../../redux/actions/learningCenterSettingsActions";
import { Settings } from "../../views/Settings";
import { BannerSettings } from "../../views/Settings/Banner";
import { LogoSettings } from "../../views/Settings/Logo";
import Logo from "../../components/Logo";
import { defaultBannerImages } from "../../constants";

const learningCenterSettingsTabsInfo = [
  { tabName: "Logo", tabSubtitle: "settings.logoSubtitle" },
  {
    tabName: "Banner",
    tabSubtitle: "settings.bannerSubtitle"
  }
  /*{ tabName: "Theme", tabSubtitle: "" }*/
];

const getBannerImages = bannerImages => {
  return bannerImages
    ? bannerImages.map((bannerImage, index) => {
        if (bannerImage.imgPath && bannerImage.imgPath === "default") {
          return { ...defaultBannerImages[index], default: true };
        } else {
          return bannerImage;
        }
      })
    : [];
};
class LearningCenterSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleLearningCenterCaptionChange = (event, inputComplete = false) => {
    this.props.actions.updateText(
      "learningCenterCaption",
      event.target.value,
      inputComplete
    );
  };

  handleLogoSettingChange = newSetting => () => {
    this.props.actions.updateText("logoStyle", newSetting);
  };

  handleLogoUpload = (imageFile, rawFile) => {
    this.props.actions.updateImage(imageFile, rawFile);
  };

  handleBannerImagesChange = (rawFile, index, status) => {
    this.props.actions.updateBannerImage(rawFile, index, status);
  };

  handleBannerImageReset = index => {
    this.props.actions.updateBannerImage("default", index, "default");
  };

  deleteBannerImage = index => {
    this.props.actions.deleteBannerImage(index);
  };

  changeNoBannerOption = option => {
    this.props.actions.changeNoBannerOption(option);
  };

  componentDidMount() {
    this.props.actions.fetchSettings();
    this.props.actions.fetchBanners();
  }

  render() {
    const logo = <Logo logo={this.props.logoImage} />;
    const tabsContent = [
      <LogoSettings
        logoStyle={this.props.logoStyle}
        learningCenterCaption={this.props.learningCenterCaption}
        logo={logo}
        onTextInput={this.handleLearningCenterCaptionChange}
        onLogoSettingChanged={this.handleLogoSettingChange}
        onLogoUpload={this.handleLogoUpload}
      />,
      <BannerSettings
        bannerImages={this.props.bannerImages}
        handleNoBannerOptionChange={this.changeNoBannerOption}
        noBanner={this.props.noBanner}
        onBannerImagesChange={this.handleBannerImagesChange}
        onBannerImageReset={this.handleBannerImageReset}
        deleteBannerImage={this.deleteBannerImage}
      />
    ];
    return (
      <Settings
        tabsInfo={learningCenterSettingsTabsInfo}
        tabsContent={tabsContent}
      />
    );
  }
}

const mapStateToProps = state => ({
  logoImage: state.learningCenterSettingsState.logoImage,
  learningCenterCaption:
    state.learningCenterSettingsState.learningCenterCaption,
  logoStyle: state.learningCenterSettingsState.logoStyle,
  customColor: state.learningCenterSettingsState.customColor,
  noBanner: state.learningCenterSettingsState.noBanner,
  bannerImages: getBannerImages(state.learningCenterSettingsState.bannerImages),
  error: state.learningCenterSettingsState.error
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(settingsActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningCenterSettings);
